module.exports = __webpack_public_path__ + "src/app/images/slight_right.svg";